import {EVENTS_NAME} from '../../config.js'

const {LEAD_TRIGGERED_DETAIL_PRI_AND_PRO} = EVENTS_NAME

// INPUT:  event='Lead Triggered', page_name_origin='detail',
// lead_type='Detail Ad Replied Email'|'Detail Phone Called'|'Detail Ad Replied Whatsapp'|'Financed Purchase Phone Called'|'Financed Purchase Email'
// OUTPUT: ['Lead Triggered Detail Pri And Pro Web']

export const getDetailPriAndProEvents = ({event, properties}) => {
  const matches =
    event === LEAD_TRIGGERED_DETAIL_PRI_AND_PRO.EVENT &&
    properties.page_name_origin === LEAD_TRIGGERED_DETAIL_PRI_AND_PRO.PAGE_NAME_ORIGIN &&
    LEAD_TRIGGERED_DETAIL_PRI_AND_PRO.LEAD_TYPES.includes(properties.lead_type)

  if (!matches) return []

  return [LEAD_TRIGGERED_DETAIL_PRI_AND_PRO.EVENT_OPTIMIZELY]
}
